module.exports = __webpack_public_path__ + "static/media/Background.78b691cc.webp";